export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  // content is now loaded dynamically from public/content/{id}.html
  content: string; 
  date: string;
  author: string;
  tags: string[];
}

export const BLOGS: BlogPost[] = [
  {
    id: 'agentic-rate-limiting',
    title: 'The Traffic Cop Agent: AI-Driven Rate Limiting',
    excerpt: 'Reimagining the classic Rate Limiter as an intelligent agent that dynamically adjusts throughput based on system stress levels.',
    date: '2025-12-28',
    author: 'QED AI',
    tags: ['System Design', 'AI Agents', 'Reliability', 'Security'],
    content: '' // Loaded at runtime
  },
  {
    id: 'swarm-intelligence-hashing',
    title: 'Swarm Intelligence: Consistent Hashing & Agent Clusters',
    excerpt: 'Using the principles of Consistent Hashing to manage distributed swarms of AI agents without losing context.',
    date: '2025-12-28',
    author: 'QED AI',
    tags: ['Distributed Systems', 'Swarm AI', 'Scalability'],
    content: '' // Loaded at runtime
  },
  {
    id: 'autonomous-remediation',
    title: 'The Self-Healing Infrastructure: Agents as SREs',
    excerpt: 'Replacing incident alerts with Agents. How autonomous loops perceive incidents, reason about root causes, and take remediation actions.',
    date: '2025-12-28',
    author: 'QED AI',
    tags: ['AI Agents', 'SRE', 'DevOps', 'Production'],
    content: '' // Loaded at runtime
  }
];
